<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pxcgME/tc-custom/9781558328709.jpg?1729082652246" alt="This image is the cover for the book Joy of Pickling"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Joy of Pickling
      </h1>
      <p class="bookDescription body article font2">
        <b>Discover the tools and techniques you need for pickling success, with 300 recipes from kimchi to sauerkraut and even a peck of pickled peppers!</b><br/><br/>Putting up pickles is a time-honored technique for preserving the harvest and getting the most out of fresh produce, whether you grow it yourself or purchase it at your local market. But pickling isn’t just about preserving: It’s a way to create mouthwatering condiments and side dishes that add endless variety and vibrant flavors to the table.<br/><br/>Making these salty, sour, sweet, and tangy treats isn’t hard, as long as you have this authoritative and user-friendly volume to guide you. This new edition includes 50 brand-new recipes, many focused on the latest trend in pickling: fermentation. It also includes:An international range of pickles from American favorites to adventuresome ideas from Asia, the Middle East, and EuropeRecipes for canned and put-up pickles as well as quick pickles for the fridge or freezerNew techniques for preventing yeast and mold growths on fermented picklesRecipes for using pickled produce in chutneys, salsas, relishes, and moreExpert safety guidance and tips<br/><br/>From Lower East Side Full-Sour Dills to Cabbage and Radish Kimchi, Pickled Whole Watermelons to Quick Pickled Baby Corn, the 300 recipes in <i>The Joy of Pickling</i> make the harvest last, deliciously and freshly, all year round.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Linda Ziedrich, Christopher Kimball
      </h2>
      
      <p class="authorDescription body article">Linda Ziedrich is a certified Master Food Preserver and Master Gardener who frequently teaches classes and performs demos on a range of preserving topics across the Pacific Northwest. She is also the author of The Joy of Pickling, now in its third edition, and The Joys of Jams, Jellies, and Other Sweet Preserves. She blogs at A Gardener's Table. She lives in the Willamette Valley of Oregon.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harvard Common Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3d64b868